import { TextInput } from '@sede-x/shell-ds-react-framework';
import styled from 'styled-components';

export const StyledTextInput = styled(TextInput)`
  > div[type='prefix'] {
    font-size: 13px;
    white-space: nowrap;
  }
`;
